import React, { useState, useEffect, useRef } from 'react';
import {ChevronLeft, ChevronRight} from 'lucide-react';

const BASE_IMAGES = [
  'https://static.lumi.new/89/897c8893f1df13f4105cd1b670d4008a.webp',
  'https://static.lumi.new/97/977dbaa976a66e3a0c23770ce3ae0218.webp',
  'https://static.lumi.new/36/36d5af6ade4bdbb2ea3d3c3710844a17.webp',
  'https://static.lumi.new/4b/4be9878e418d0e4eddb53aaa9967c2e0.webp',
  'https://static.lumi.new/8c/8c71a08eb1daebfa3fb60aaee63babab.webp',
  'https://static.lumi.new/d2/d2bb75512a846e7a8e61da6cc296fefa.webp',
  'https://static.lumi.new/96/9619c7ae801b255620e4f6dcb807952e.webp',
  'https://static.lumi.new/55/5507a1586755952acd73f30f9087da07.webp',
  'https://static.lumi.new/fa/fa5e9e71955217fc3f96e1f30450717e.webp',
  'https://static.lumi.new/80/801390ebb65e81b3e1b40c720600b791.webp',
  'https://static.lumi.new/93/93625932f38f743de8dc0d61dacddc96.webp',
  'https://static.lumi.new/ed/ed788ae09b23d63a7d5d885e85be6b4d.webp',
  'https://static.lumi.new/0b/0b88263aa3664b5408fbf2508611eeea.webp',
  'https://static.lumi.new/0e/0e28eed596698b836195a21f82301fad.webp',
  'https://static.lumi.new/a3/a3f2e315b9a45932ceb982395254c229.webp',
  'https://static.lumi.new/c3/c3d7dcb600c54992de78db62dae02282.webp',
  'https://static.lumi.new/43/43cc86b019ae19ae99dfcb08a6c55ce6.webp',
  'https://static.lumi.new/97/9796997771e26ea908a0a3c3fa5bfddb.webp',
  'https://static.lumi.new/52/5228fdebf378cc8656e48f35ae6ef514.webp',
  'https://static.lumi.new/fa/fa0b6f29fde780992763f806393c40ae.webp',
  'https://static.lumi.new/77/776fb0247a538701c9d03c14f71c2f34.webp',
  'https://static.lumi.new/65/654764e245116396a66d2ac0b55fe1ee.webp',
  'https://static.lumi.new/88/889c58ef8fe7e7ca7282070ea1bfc693.webp',
  'https://static.lumi.new/e5/e572ad84208c049a973fded461426d9a.webp',
  'https://static.lumi.new/93/933d3a705a75da3fb14f01224ee3a47e.webp',
  'https://static.lumi.new/04/040ab3808ebc21a41194fc2cec49e780.webp',
  'https://static.lumi.new/f3/f3de9be4d8b67fbae03feeff356b118a.webp',
  'https://static.lumi.new/35/359bd0040f286c538362495cc284de6b.webp',
  'https://static.lumi.new/e4/e4a47f2b240ca169153fcfb0b4a75d05.webp',
  'https://static.lumi.new/f0/f0ef9f9e1df8cbb7c6ce49d888fc39d2.webp',
  'https://static.lumi.new/47/47817c2446ab880f6769048195155573.webp',
  'https://static.lumi.new/76/7650a32eb095fed3b468ffb801c6a142.webp',
  'https://static.lumi.new/e9/e9b361c1423ba0e451ca2345d808ec54.webp',
  'https://static.lumi.new/19/19db7c10b568dce1a37ee84ba362eb9a.webp',
  'https://static.lumi.new/70/70ab7ae850836105e7fd069a77b0a560.webp',
  'https://static.lumi.new/5a/5afca7b24fac92f101d1ff325ba3695d.webp',
  'https://static.lumi.new/de/de74dca3ef47256352b8e4daefcd9044.webp',
  'https://static.lumi.new/55/550db308e3afc3c8c4a17f66ee42dff6.webp',
  'https://static.lumi.new/bf/bf04bc1c360b71019995b314fbba1b91.webp',
  'https://static.lumi.new/29/29b3149330d190a641ba5f64fc98e7dc.webp',
  'https://static.lumi.new/90/909ca838cd26ad17d2f01d6a156b1875.webp',
  'https://static.lumi.new/13/13ef31463cd03a4c188c4dee89a14bf8.webp',
  'https://static.lumi.new/b5/b5ed64cf45848348ef402a236f483b72.webp',
  'https://static.lumi.new/1e/1e5778fce7a288f159d0296ffb8b2c4c.webp',
  'https://static.lumi.new/31/31c85fcf6bfe5275d59bd278e9d4f300.webp',
  'https://static.lumi.new/f3/f3f4ce80514fc00a5cba4435d14be6e0.webp',
  'https://static.lumi.new/a8/a8a4184b2a4c08c314604a9617834190.webp',
  'https://static.lumi.new/e4/e4a63ee4d4b4c3cfdc902507a94fa4db.webp',
  'https://static.lumi.new/8d/8ddbe214a217d38f0a730a24de24d017.webp',
  'https://static.lumi.new/67/672d19619c2710a2014556c8d315a433.webp',
  'https://static.lumi.new/97/9750c1dd47d445251aad189657a2e1ba.webp',
  'https://static.lumi.new/87/87616199fb461a4a4fdedb3126f10c3c.webp',
  'https://static.lumi.new/3e/3e1b5d8ca0783af60476ca1d42331dfb.webp',
  'https://static.lumi.new/19/19b7bfa10369fbf7f0cb3de3799b5ea4.webp',
  'https://static.lumi.new/ad/ad801a13d8af1272f5c2c6f662514167.webp',
  'https://static.lumi.new/5f/5fd60c31efe9bcab505fb13d117e6e0a.webp',
  'https://static.lumi.new/31/3174787d285f947c9df16dbd02b400c9.webp',
  'https://static.lumi.new/f7/f706ae05882647b16e72337915d8a928.webp',
  'https://static.lumi.new/1d/1d1a1f4a7696e907eee77ae7897205ed.webp',
  'https://static.lumi.new/42/42583dfd06cf4c194b023bc479aaa186.webp',
  'https://static.lumi.new/e0/e08c412ae402acf29d7f9ec19c4b7cc9.webp',
  'https://static.lumi.new/29/291ecb12fbdc2d474a432b6edb61e71c.webp',
  'https://static.lumi.new/fd/fd671ad53b6fc3bd4a2d4d2889327f43.webp',
  'https://static.lumi.new/1a/1a60c43026bb842278d3ff4a950a7fad.webp',
  'https://static.lumi.new/b0/b02f6201bf99c3b228f7708718e0c72a.webp',
  'https://static.lumi.new/73/734d2a4235712dfb5fbdc86da9f77caf.webp',
  'https://static.lumi.new/5c/5c8ec2c030dcb928c88f3b965065a8a3.webp',
  'https://static.lumi.new/54/54e57708f34fa2f0c25bab2b9ec960c2.webp',
  'https://static.lumi.new/a3/a3910f1505e9cd2679c3dd9eb98392a0.webp',
  'https://static.lumi.new/a8/a8751c4c2226f6d676bbca469681ef99.webp',
  'https://static.lumi.new/a6/a646d7cc2f9d37c0eb9fe93adf14400f.webp',
  'https://static.lumi.new/fd/fd671ad53b6fc3bd4a2d4d2889327f43.webp',
  'https://static.lumi.new/bd/bd0753bcca921f737ecfd307ea09b1a4.webp',
  'https://static.lumi.new/3d/3d59f31b21fb9e8bbb7ccf5762aab846.webp',
];

const ITEM_WIDTH = 336; // w-80 (320px) + gap-4 (16px)

function shuffleArray(array: string[]) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export default function WorkGallery() {
  const [images, setImages] = useState<string[]>([]);
  const [paused, setPaused] = useState(false);
  const trackRef = useRef<HTMLDivElement>(null);
  const offsetRef = useRef(0);
  const rafRef = useRef<number>(0);
  const lastTimeRef = useRef<number>(0);
  const manualScrollRef = useRef(false);
  const resumeTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    setImages(shuffleArray(BASE_IMAGES));
  }, []);

  // Animação manual via requestAnimationFrame quando o auto-scroll está pausado
  // (as setas controlam offsetRef diretamente)
  useEffect(() => {
    if (images.length === 0) return;

    const totalWidth = images.length * ITEM_WIDTH;
    const speed = 60; // px/s — velocidade do auto-scroll

    const animate = (timestamp: number) => {
      if (!lastTimeRef.current) lastTimeRef.current = timestamp;
      const delta = timestamp - lastTimeRef.current;
      lastTimeRef.current = timestamp;

      if (!paused && !manualScrollRef.current) {
        offsetRef.current = (offsetRef.current + (speed * delta) / 1000) % totalWidth;
      }

      if (trackRef.current) {
        trackRef.current.style.transform = `translateX(-${offsetRef.current}px)`;
      }

      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafRef.current);
  }, [images, paused]);

  const scroll = (direction: 'left' | 'right') => {
    if (images.length === 0) return;
    const totalWidth = images.length * ITEM_WIDTH;
    const step = ITEM_WIDTH * 3;

    manualScrollRef.current = true;
    clearTimeout(resumeTimeoutRef.current);

    offsetRef.current =
      direction === 'right'
        ? (offsetRef.current + step) % totalWidth
        : (offsetRef.current - step + totalWidth) % totalWidth;

    resumeTimeoutRef.current = setTimeout(() => {
      manualScrollRef.current = false;
      lastTimeRef.current = 0;
    }, 600);
  };

  // Duplicar para scroll infinito (3x)
  const allImages = [...images, ...images, ...images];

  return (
    <>
      <section
        className="relative bg-gradient-to-b from-gray-900 to-gray-800 py-10 overflow-hidden"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div className="w-full">
          <div className="relative h-60 md:h-72 overflow-hidden">
            {/* Track controlado via JS */}
            <div
              ref={trackRef}
              className="absolute flex gap-4 will-change-transform"
              style={{ transform: 'translateX(0px)' }}
            >
              {allImages.map((url, index) => (
                <div key={index} className="flex-shrink-0 w-80 h-60 md:h-72">
                  <div
                    className="rounded-lg overflow-hidden shadow-2xl h-full relative"
                  >
                    <img
                      src={url}
                      alt="Trabalho Pinhacorada"
                      className="w-full h-full transition-transform duration-300 hover:scale-105 object-cover"
                      loading="lazy"
                    />
                    <img
                      src="https://static.lumi.new/d2/d2420d10297c1cc2cf7868802e04f7fd.webp"
                      alt="Pinhacorada Logo"
                      className="absolute top-2 left-2 h-8 w-auto opacity-90 drop-shadow-lg"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Gradientes decorativos */}
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-gray-900 to-transparent pointer-events-none z-10" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-gray-800 to-transparent pointer-events-none z-10" />

        {/* Setas de navegação */}
        <button
          onClick={() => scroll('left')}
          aria-label="Anterior"
          className="absolute left-3 top-1/2 -translate-y-1/2 z-20 bg-black bg-opacity-50 hover:bg-opacity-80 text-white rounded-full p-2 transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-white"
        >
          <ChevronLeft size={24} />
        </button>
        <button
          onClick={() => scroll('right')}
          aria-label="Seguinte"
          className="absolute right-3 top-1/2 -translate-y-1/2 z-20 bg-black bg-opacity-50 hover:bg-opacity-80 text-white rounded-full p-2 transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-white"
        >
          <ChevronRight size={24} />
        </button>
      </section>


    </>
  );
}
